<template>
  <!-- 处方明细 -->
  <div class="packagingBox">
    <!-- 审核中图标 -->
    <img
      v-if="prescripItem.state === '1'"
      class="packagingImg"
      src="@funcPuzzle/mini_patient/underReview.png"
    />
    <!-- 退款成功图标 -->
    <img
      v-else-if="String(prescripItem.payState) === '3'"
      alt="已退费"
      class="packagingImg"
      src="@funcPuzzle/mini_patient/refunded_status.png"
    />
    <div class="prescrip-title-wrap">
      <div class="packagingLabel">
        {{ getKeyValueText('prescrip_type', prescripItem.prescripType) + '处方' }}
      </div>
    </div>
    <div
      v-if="
        String(coverDrugsOption[prescripItem.prescripType]) === '1' &&
        String(prescripItem.payState) !== '1'
      "
      class="nonPayment"
    >
      <img class="nonPaymentImg" src="@funcPuzzle/mini_patient/groundGlass.png" />
      <div class="nonPaymentText">
        {{ getKeyValueText('prescrip_type', item.prescripType) + '处方药品信息支付后显示' }}
      </div>
    </div>
    <div v-else class="prescrip-info">
      <div class="content" v-if="['4', '7'].includes(prescripItem.prescripType)">
        <!-- 4 蒙药（蒙） 7: 一人一方 -->
        <KcMyShow
          :drugList="prescripItem.prescripDrugsList"
          :templateType="prescripItem.templateType"
          :allInBool="allInBool"
        />
      </div>
      <div v-else-if="['1', '2', '8'].includes(prescripItem.prescripType)">
        <!-- 1: "中成药", 2: "西药" 8: "蒙药" -->
        <KcXyShow :drugList="prescripItem.prescripDrugsList" />
      </div>
      <div v-else>
        <!-- 3: "中草药" 5: "中药小包装", 6: "中药颗粒" -->
        <KcZyShow :prescripItem="prescripItem" />
      </div>
    </div>
    <KcPreBottom :prescripItem="prescripItem" @changeAllInBool="changeAllInBool" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getBusinessDicList } from '@/views/funcPuzzle/utils/index.js'
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import KcMyShow from './kc-my-show.vue'
import KcXyShow from './kc-xy-show.vue'
import KcZyShow from './kc-zy-show.vue'
import KcPreBottom from './kc-pre-bottom.vue'
export default {
  name: 'PrescripDetail',
  components: {
    KcPreBottom,
    KcMyShow,
    KcXyShow,
    KcZyShow
  },
  props: {
    detail: {
      // 处方详情
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    prescripItem() {
      let prescripDrugsList = []
      try {
        const target = JSON.parse(this.detail.drugs)
        if (target && target.drugList) {
          prescripDrugsList = target.drugList
        }
      } catch (e) {
        console.log(e)
      }
      return {
        ...this.detail,
        prescripDrugsList
      }
    }
  },
  data() {
    return {
      getKeyValueText,
      // prescripItem: {},
      coverDrugsOption: {
        // 是否需要遮挡处方药品配置，默认不遮挡
      },
      allInBool: true
    }
  },
  beforeMount() {
    this.getCoverDrugsOption()
  },
  methods: {
    async getCoverDrugsOption() {
      /**
       * 获取需要遮挡处方药品配置
       * 默认不打码，只有配置了打码才校验已缴费后才展示药品
       * **/
      try {
        const { code, DoctorServicePackageList, codeDesc } = await getBusinessDicList({
          tableName: 'prescription_drugs_coding',
          code: this.userInfos.hospitalID,
          isValid: 1
        })
        if (!DoctorServicePackageList || !DoctorServicePackageList.length) {
          return
        }

        let targetJson = DoctorServicePackageList.find(
          item => item.code === this.userInfos.hospitalID
        )
        if (!targetJson || !targetJson.value) {
          return
        }
        let temp
        try {
          temp = JSON.parse(targetJson.value)
        } catch (e) {
          console.log(e)
          temp = {}
        }
        this.coverDrugsOption = temp
      } catch (e) {
        console.log(e)
      }
    },
    onUpdateDetail(data) {
      // 退款后 更新详情
      this.$emit('updateDetail', data)
    },
    changeAllInBool(val) {
      this.allInBool = val
    }
  }
}
</script>
<style lang="scss">
.packagingBox {
  margin: 0 auto;
  position: relative;
  width: 14.634667rem;
  background-color: #f9f9f9;
  border-radius: 0.170667rem;

  .chineseMedicineBox {
    width: 12.373333rem;
    margin-left: 0.682667rem;
    margin-top: 0.682667rem;

    .chineseMedicine {
      font-size: 0.64rem;
      color: #222;
      padding-right: 0.426667rem;
    }
  }

  .chineseMedicineBottom {
    position: relative;
    // box-sizing: border-box;
    // margin: .682667rem auto;
    // width: 13.269333rem;
    // min-height: 4.010667rem;
    // background-color: #fff;
    // color: #888;
    // font-size: .512rem;
    // border-radius: .170667rem;
    padding: 0.512rem 0.64rem;
    border-bottom: 0.426667rem solid #f8f8f8;

    .diamond {
      position: absolute;
      top: 0.298667rem;
      right: 0.682667rem;
      padding: 0.213333rem 0.256rem;
      color: #222;
      font-size: 0.512rem;
      background-color: #f2f2f2;
      border-radius: 0.085333rem;
    }
  }

  .packagingImg {
    position: absolute;
    top: 0.384rem;
    right: 0.384rem;
    width: 2.517333rem;
    height: 2.048rem;

    &.txt {
      width: 2.517333rem;
      height: 2.517333rem;
      font-size: 0.682667rem;
      line-height: 2.517333rem;
      text-align: center;
      border: 0.085333rem dashed #222;
      transform: rotate(45deg);
      transform-origin: center center;
      border-radius: 100%;
      background: #fff;
    }
  }

  .prescrip-title-wrap {
    padding-top: 0.597333rem;
    display: flex;
    align-items: center;
  }

  .packagingLabel {
    margin-right: 0.426667rem;
    margin-left: 0.682667rem;
    max-width: 4.266667rem;
    height: 0.853333rem;
    line-height: 0.853333rem;
    text-align: center;
    background-color: #e7f4ff;
    color: #0089ff;
    font-size: 0.512rem;
    border-radius: 0.085333rem;
  }

  .pharmacy {
    width: 100%;
    border-bottom: 0.021333rem solid #ececec;
    font-size: 0.64rem;
    padding: 0.682667rem 0 0.682667rem 0;

    .pharmacyTitle {
      color: #222;
      padding-left: 0.682667rem;
    }

    .pharmacyText {
      color: #888888;
      padding: 0.682667rem 0 0 0.682667rem;
    }
  }

  .obstinate {
    margin: 0.426667rem auto;
    color: #222222;
    font-size: 0.64rem;

    .obstinateImg {
      width: 0.64rem;
      height: 0.64rem;
      padding-left: 0.234667rem;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      /* Internet Explorer 9*/
      -moz-transform: rotate(90deg);
      /* Firefox */
      -webkit-transform: rotate(90deg);
      /* Safari 和 Chrome */
      -o-transform: rotate(90deg);
      /* Opera */
    }

    .obstinateImgNone {
      width: 0.64rem;
      height: 0.64rem;
      transform: rotate(-90deg);
      -ms-transform: rotate(-90deg);
      /* Internet Explorer 9*/
      -moz-transform: rotate(-90deg);
      /* Firefox */
      -webkit-transform: rotate(-90deg);
      /* Safari 和 Chrome */
      -o-transform: rotate(-90deg);
      /* Opera */
    }
  }

  .pharmacist {
    width: 100%;
    min-height: 2.005333rem;
    line-height: 2.005333rem;
    font-size: 0.64rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.021333rem solid #ececec;

    .pharmacistTitle {
      min-width: 2.133333rem;
      padding-left: 0.682667rem;
      color: #888888;
    }

    .pharmacistName {
      color: #222222;
      padding-right: 0.682667rem;
    }
  }

  .packagingPrice {
    width: 100%;
    height: 2.005333rem;
    line-height: 2.005333rem;
    display: flex;
    justify-content: space-between;

    .pharmacistTitle {
      font-size: 0.64rem;
      padding-left: 0.682667rem;
      color: #888888;
    }

    .priceBox {
      display: flex;
      align-items: center;
      padding-right: 0.682667rem;

      .pharmacistText {
        display: inline-block;
        color: #222;
      }

      .processCost {
        display: inline-block;
        font-size: 0.512rem;
        color: #222;
      }

      .priceName {
        display: inline-block;
        margin-left: 0.170667rem;
      }
    }
  }

  .packagingBottom {
    width: 100%;
    height: 2.005333rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .packagingBtn {
      width: 4.693333rem;
      height: 1.152rem;
      line-height: 1.152rem;
      text-align: center;
      border: 0.021333rem solid #cecece;
      border-radius: 0.554667rem;
      color: #222;
      font-size: 0.64rem;
      margin-right: 0.426667rem;
    }

    .bg-blue {
      background-color: #0089ff;
      color: #fff;
      border: 0.021333rem solid #0089ff;
    }
  }

  .refund-btn {
    padding: 0.426667rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
  }

  .nonPayment {
    position: relative;
    width: 13.269333rem;
    height: 6.570667rem;
    margin: 0.490667rem auto;
    border-radius: 0.170667rem;
    background-color: #fff;

    .nonPaymentImg {
      width: 100%;
      height: 6.570667rem;
    }

    .nonPaymentText {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.64rem;
      color: #0089ff;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
